export const handleCtrlLink = (e, href) => {
    e.preventDefault(); 
if (e.ctrlKey || e.metaKey) {
    e.stopPropagation(); 
    window.open(href, '_blank');

}
};